// TODO [LOWA-30534] from: https://tiny.amazon.com/c422u07y

export enum Language {
    German = "de-DE",
    English = "en-US",
    Spanish = "es-ES",
    French = "fr-FR",
    Indonesian = "id-ID",
    Italian = "it-IT",
    Japanese = "ja-JP",
    Korean = "ko-KR",
    Portuguese = "pt-BR",
    SimplifiedChinese = "zh-CN",
    TraditionalChinese = "zh-TW",
}

export const LanguageDisplayNames: Record<Language, string> = {
    [Language.German]: "Deutsch",
    [Language.English]: "English",
    [Language.Spanish]: "Español",
    [Language.French]: "Français",
    [Language.Indonesian]: "Bahasa Indonesia",
    [Language.Italian]: "Italiano",
    [Language.Japanese]: "日本語",
    [Language.Korean]: "한국어",
    [Language.Portuguese]: "Português (Brasil)",
    [Language.SimplifiedChinese]: "中文(简体)",
    [Language.TraditionalChinese]: "中文(繁體)",
};

// use English as fallback language
export const DEFAULT_FALLBACK_LANGUAGE = Language.English;
